import { SpringboardService } from '@app/shared/services/springboard.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IframeViewerComponent } from '@app/web/common/iframe-viewer/iframe-viewer.component';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import {
    ActivityOutgoingEvent,
    ActivityModel,
    UserModel,
    UserService,
    ToggleFavoriteActivityInteractor,
} from '@together/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastSnackBarComponent } from '@app/shared/components/toast-snack-bar/toast-snack-bar.component';

export interface PlayDemoModalComponentData {
    activity: ActivityModel;
}

@Component({
    selector: 'app-play-demo-modal',
    templateUrl: './play-demo-modal.component.html',
    styleUrls: ['./play-demo-modal.component.scss'],
})
export class PlayDemoModalComponent extends SimpleModalComponent<PlayDemoModalComponentData, void> implements OnInit {
    hasStarted: boolean = false;
    activity: ActivityModel;

    @ViewChild('admin') admin: IframeViewerComponent;
    @ViewChild('child') child: IframeViewerComponent;

    public isLoggedIn = false;
    public isFav = false;

    private currentUser: UserModel;

    constructor(
        private readonly userService: UserService,
        private readonly springboard: SpringboardService,
        private toggleFavoriteActivity: ToggleFavoriteActivityInteractor,
        private snackBar: MatSnackBar,
    ) {
        super();
    }

    async ngOnInit() {
        this.isLoggedIn = await this.userService.isLoggedIn();
        if (this.isLoggedIn) {
            this.currentUser = await this.userService.getUser();
        }
        this.isFav = this.isLoggedIn && this.currentUser?.isFavoriteActivity(this.activity.id);
    }

    startDemo() {
        this.hasStarted = true;
    }

    handleAdminEvent(event: ActivityOutgoingEvent) {
        if (event.type === 'activity') {
            this.child.handleEvent(event.payload);
        }
    }

    handleChildEvent(event: ActivityOutgoingEvent) {
        if (event.type === 'activity') {
            this.admin.handleEvent(event.payload);
        }
    }

    public async toggleActivityAsFavorite(): Promise<void> {
        this.isFav = !this.isFav;
        if (this.currentUser) {
            await this.toggleFavoriteActivity
                .execute(this.currentUser, this.activity.id)
                .then(favoriteActivities => {
                    this.currentUser.favoriteActivities = favoriteActivities;
                    this.springboard.refreshUser(this.currentUser);
                    if (this.isFav) {
                        this.snackBar.openFromComponent(ToastSnackBarComponent, {
                            duration: 3000,
                            data: { text: 'Added to favorites!', icon: 'checked-round' },
                        });
                    }
                })
                .catch(() => {
                    this.isFav = !this.isFav;
                });
        }
    }
}
